let loadPromise = null

// Loads the Google Maps JS API (with the Places library) once per page lifetime.
// Subsequent calls return the same in-flight promise to prevent duplicate <script> tags
// when several Stimulus controllers connect concurrently.
export function loadGoogleMaps(apiKey) {
  if (window.google?.maps?.places) return Promise.resolve()
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve) => {
    window.__googleMapsCallback = () => {
      delete window.__googleMapsCallback
      resolve()
    }
    const script = document.createElement("script")
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=__googleMapsCallback`
    script.async = true
    document.head.appendChild(script)
  })

  return loadPromise
}
